import React from "react";
import AdminLayout from "../../layout";

const Analytics = () => {
  return <AdminLayout>Analytics</AdminLayout>;
};

export default Analytics;
